import { z } from 'zod';
import { SchemaEmail, SchemaPhoneNumber } from '@axiom/types';

export const OnboardingFirstDayFormSchema = z.object({
  notes: z.string().min(1, { message: 'Required' }),
  clientName: z.string().min(1, { message: 'Required' }),
  jobTitle: z.string().nullable(),
  email: SchemaEmail.nullable(),
  phoneNumber: SchemaPhoneNumber.nullable(),
  additionalContacts: z.array(
    z.object({
      key: z.string(),
      clientName: z.string().min(1, { message: 'Required' }),
      jobTitle: z.string().nullable(),
      email: SchemaEmail.nullable(),
      phoneNumber: SchemaPhoneNumber.nullable(),
    })
  ),
});

export type OnboardingFirstDayForm = z.infer<
  typeof OnboardingFirstDayFormSchema
>;
